import React from "react";
import "./IconButton.css";
import classNames from "classnames";

export const IconButton = ({
  title = "",
  onClick,
  variant,
  children,
}: {
  title?: string;
  onClick?: any;
  variant?: string;
  children: any;
}) => {
  var iconButtonClass = classNames("icon-button", {
    [`icon-button--${variant}`]: variant,
  });

  return (
    <button title={title} className={iconButtonClass} onClick={onClick}>
      {children}
    </button>
  );
};
